/**
 * @generated SignedSource<<66b13b575f735238561d0cfe83f44d65>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveUserGroupInput = {
  id: string;
};
export type RemoveUserGroupMutation$variables = {
  input: RemoveUserGroupInput;
};
export type RemoveUserGroupMutation$data = {
  readonly removeUserGroup: {
    readonly removed: {
      readonly id: string;
    } | null | undefined;
  };
};
export type RemoveUserGroupMutation = {
  response: RemoveUserGroupMutation$data;
  variables: RemoveUserGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveUserGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveUserGroupPayload",
        "kind": "LinkedField",
        "name": "removeUserGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RemoveUserGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveUserGroupPayload",
        "kind": "LinkedField",
        "name": "removeUserGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fa140276283cb3ef29643799c5238633",
    "id": null,
    "metadata": {},
    "name": "RemoveUserGroupMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveUserGroupMutation(\n  $input: RemoveUserGroupInput!\n) {\n  removeUserGroup(input: $input) {\n    removed {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a365f643cabb8d1ba2b0b380aff2fae2";

export default node;
